export const testIds = {
  cookieBanner: {
    cookiePolicy: 'cookie-banner_cookie-policy_link',
    showCookies: 'cookie-show-cookies_link',
    accept: 'cookie-banner_accept_button',
    reject: 'cookie-banner_reject_button'
  },
  dialog: {
    close: 'dialog_close_button'
  },
  contentCollection: {
    title: 'content-collection_title'
  },
  contentItem: {
    actions: {
      trigger: 'content-item-actions_trigger_button',
      menu: {
        remove: 'content-item-actions_menu-remove_button',
        info: 'content-item-actions_menu-info_button',
        favorite: 'content-item-actions_menu-favorite_button',
        unfavorite: 'content-item-actions_menu-unfavorite_button'
      }
    },
    icon: 'content-item_icon_content',
    logo: 'content-item_logo_content',
    progress: 'content-item_progress-bar_content',
    root: 'content-item_root_content',
    title: 'content-item_title_content',
    startTime: 'content-item_start-time_content',
    npvrLogo: 'content-item-npvr-logo'
  },
  contentSheet: {
    favorite: {
      root: 'content-sheet-actions_favorite-root',
      icon: {
        favorited: 'content-sheet-actions-favorite-icon-favorited',
        unfavorited: 'content-sheet-actions-favorite-icon-unfavorited'
      },
      label: 'content-sheet-actions_favorite_label'
    },
    rentingDialog: {
      emailField: 'content-sheet_renting-dialog_email-field',
      header: 'content-sheet_renting-dialog_header',
      passwordField: 'content-sheet_renting-dialog_password-field',
      periodText: 'content-sheet_renting-dialog_period-text',
      root: 'content-sheet_renting-dialog_root',
      termsCheckbox: 'content-sheet_renting-dialog_terms-checkbox',
      termsLink: 'content-sheet_renting-dialog_terms-link',
      termsText: 'content-sheet_renting-dialog_terms-text',
      title: 'content-sheet_renting-dialog_title',
      submitButton: 'content-sheet_renting-dialog_submit-button',
      waiverCheckbox: 'content-sheet_renting-dialog_waiver-checkbox'
    },
    rentingTermsDialog: {
      backButton: 'content-sheet_renting-terms-dialog_back-button',
      header: 'content-sheet_renting-terms-dialog_header',
      root: 'content-sheet_renting-terms-dialog_root'
    },
    versionSelectionDialog: {
      root: 'content-sheet_version-selection-dialog_root',
      header: 'content-sheet_version-selection-dialog_header',
      title: 'content-sheet_version-selection-dialog_title',
      item: {
        actionText: 'content-sheet_version-selection-dialog_item-action-text',
        button: 'content-sheet_version-selection-dialog_item-button',
        logo: 'content-sheet_version-selection-dialog_item-logo'
      }
    }
  },
  contentSlider: {
    header: {
      actions: {
        all: 'content-slider_header-actions-all_link',
        next: 'content-slider-header-actions-next_link',
        prev: 'content-slider-header-actions-prev_link'
      },
      title: 'content-slider_header-title_content'
    },
    root: 'content-slider_root_content'
  },
  header: {
    logo: 'header_logo_link',
    navigation: {
      frontPage: 'header-navigation_front-page_link',
      liveTv: 'header-navigation_live-tv_link',
      tvGuide: 'header-navigation_tv-guide_link',
      universeRentShop: 'header-navigation_universe-rent-shop_link',
      universeMovie: 'header-navigation_universe-movie_link',
      universeSeries: 'header-navigation_universe-series_link',
      universeKids: 'header-navigation_universe-kids_link',
      universeShows: 'header-navigation_universe-shows_link'
    },
    profile: {
      trigger: 'header-profile_trigger_button',
      menu: {
        logout: 'header-profile-menu-logout_button',
        root: 'header-profile-menu-root_content',
        emailScreen: {
          cancelButton: 'header-profile-menu-email-screen-cancel-button',
          header: 'header-profile-menu-email-screen-header',
          input: 'header-profile-menu-email-screen-input',
          root: 'header-profile-menu-email-screen-root',
          submitButton: 'header-profile-menu-email-screen-submit-button',
          textField: 'header-profile-menu-email-screen-text-field'
        },
        homeScreen: {
          header: 'header-profile-menu-home-screen-header',
          email: {
            input: 'header-profile-menu-home-screen-email-input',
            button: 'header-profile-menu-home-screen-email-button'
          },
          password: {
            input: 'header-profile-menu-home-screen-password-input',
            button: 'header-profile-menu-home-screen-password-button'
          }
        },
        passwordScreen: {
          cancelButton: 'header-profile-menu-password-screen-cancel-button',
          header: 'header-profile-menu-password-screen-header',
          root: 'header-profile-menu-password-screen-root',
          submitButton: 'header-profile-menu-password-screen-submit-button'
        }
      }
    },
    search: {
      input: {
        clear: 'header-search_clear_button',
        field: 'header-search_input_field',
        icon: 'header-search_input_icon'
      }
    }
  },
  login: {
    coverImage: 'login_cover-image_content',
    header: 'login_header_content',
    headerIcon: 'login_header-icon_content',
    headerText: 'login_header-text_content',
    email: 'login_email_field',
    password: 'login_password_field',
    displayPassword: 'login_display-password_button',
    problems: 'login_problems_link',
    errorMessage: 'login_error-message_content',
    submit: 'login_submit_button',
    forgotPassword: 'login_forgot-password_link',
    createLogin: 'login_create-login_link',
    gdprText: 'login_gdpr-text_content',
    readGdpr: 'login_read-gdpr_link',
    forgotPasswordDialog: {
      dialog: 'login_forgot-password-modal_modal',
      headerText: 'login_forgot-password-modal-header-text_content',
      text: 'login_forgot-password-modal-text_content',
      email: 'login_forgot-password-modal-email_field',
      sendMail: 'login_forgot-password-modal-send-mail_button'
    },
    gdprModal: {
      dialog: 'login_gdpr-modal_modal',
      text: 'login_gdpr-modal-text_content'
    }
  },
  recordingLabel: {
    root: 'recording-label-root'
  },
  moviesheet: {
    dialog: 'moviesheet_modal',
    coverImage: 'moviesheet_cover-image_content',
    play: 'moviesheet_play_button',
    coverIcon: 'moviesheet_cover-icon_content',
    title: 'moviesheet_title_content',
    info: 'moviesheet_info_content',
    description: 'moviesheet_description_content',
    providerLogo: 'moviesheet_provider-logo_content',
    relatedMoviesLabel: 'moviesheet_related-movies-label_content',
    relatedMoviesStripe: 'moviesheet_related-movies-stripe_content',
    relatedMoviesStripeItem: 'moviesheet_related-movies-stripe-item_content',
    favoriteIcon: 'moviesheet_favorite-icon_button',
    favoriteLabel: 'moviesheet_favorite-label_content',
    trailerIcon: 'moviesheet_trailer-icon_content',
    trailerLabel: 'moviesheet_trailer-label_content',
    content: {
      info: {
        actors: 'moviesheet-content-info-actors',
        directors: 'moviesheet-content-info-directors'
      }
    }
  },
  search: {
    results: {
      header: 'search-results-header',
      root: 'search-results-root'
    },
    suggestions: {
      header: 'search-suggestions-header',
      link: 'search-suggestions-link',
      root: 'search-suggestions-root'
    }
  },
  seriessheet: {
    dialog: 'seriessheet_modal',
    coverImage: 'seriessheet_cover-image_content',
    title: 'seriessheet_title_content',
    info: 'seriessheet_info_content',
    favoriteIcon: 'seriessheet_favorite-icon_button',
    episodes: {
      item: {
        header: {
          actions: {
            root: 'seriessheet-episodes-item-header-actions-root'
          }
        }
      }
    },
    seasons: {
      button: 'seriessheet-seasons-button',
      root: 'seriessheet-seasons-root'
    },
    episodeItem: 'seriessheet_episode-item_content',
    episodeItemTitle: 'seriessheet_episode-item-title_content',
    episodeItemDuration: 'seriessheet_episode-item-duration_content',
    episodeItemProgressBar: 'seriessheet_episode-item-progress-bar_content'
  },
  textField: {
    error: 'text-field-error',
    inputField: 'text-field-input-field'
  },
  favoriteLists: {
    dialog: {
      dialog: 'favorite-lists_dialog_modal',
      input: 'favorite-lists_dialog-input_field',
      cancel: 'favorite-lists_dialog-cancel_button',
      delete: 'favorite-lists_dialog-delete_button',
      save: 'favorite-lists_dialog-save_button',
      item: 'favorite-lists_dialog-item_button',
      selected: {
        container: 'favorite-lists_dialog-selected_container',
        empty: 'favorite-lists_dialog-selected-empty_content',
        item: 'favorite-lists_dialog-selected-item_content',
        remove: 'favorite-lists_dialog-selected-remove_button'
      }
    },
    dropdown: {
      all: 'favorite-lists_dropdown-all_button',
      item: 'favorite-lists_dropdown-item_button',
      edit: 'favorite-lists_dropdown-edit_button',
      create: 'favorite-lists_dropdown-create_button'
    }
  },
  tvGuide: {
    dayView: {
      programs: {
        program: {
          recording: 'tv-guide-day-view-programs-program-recording',
          progressBar: 'tv-guide-day-view-programs-program-progress-bar'
        }
      }
    },
    moreInfo: {
      title: 'tv-guide_more-info-title_content',
      info: 'tv-guide_more-info-info_content',
      period: 'tv-guide_more-info-period_content',
      image: 'tv-guide_more-info-image_content'
    },
    timeline: {
      item: 'tv-guide_timeline-item_content',
      currentTime: 'tv-guide_timeline-current-time_button'
    },
    grid: {
      channelItem: 'tv-guide_grid-channel-item_button',
      programItem: 'tv-guide_grid-program-item_button'
    },
    collection: {
      itemLarge: 'tv-guide_collection-item-large_button',
      item: 'tv-guide_collection-item_button',
      play: 'tv-guide_collection-play_button',
      startOver: 'tv-guide_collection-start-over_button',
      programImage: 'tv-guide_collection-program-image_content',
      programTitle: 'tv-guide_collection-program-title_content',
      programAirtime: 'tv-guide_collection-program-airtime_content',
      programProgressBar: 'tv-guide_collection-program-progress-bar_content',
      programDescription: 'tv-guide_collection-program-description_content',
      providerLogo: 'tv-guide-collection-provider-logo',
      noResults: {
        icon: 'tv-guide_collection-no-results_icon',
        header: 'tv-guide_collection-no-results_header',
        text: 'tv-guide_collection-no-results_text'
      }
    },
    scroll: {
      live: 'tv-guide_scroll-live_button',
      forward: 'tv-guide_scroll-forward_button',
      backward: 'tv-guide_scroll-backward_button',
      root: 'tv-guide-scroll-root'
    },
    menu: {
      filter: {
        calendar: {
          item: 'tv-guide-menu-filter-calendar-item',
          list: 'tv-guide-menu-filter-calendar-list',
          root: 'tv-guide-menu-filter-calendar-root',
          trigger: 'tv-guide-menu-filter-calendar-trigger'
        },
        channels: {
          item: 'tv-guide-menu-filter-channels-item',
          list: 'tv-guide-menu-filter-channels-list',
          root: 'tv-guide-menu-filter-channels-root',
          trigger: 'tv-guide-menu-filter-channels-trigger'
        },
        favorites: {
          root: 'tv-guide-menu-filter-favorites-root',
          list: 'tv-guide-menu-filter-favorites-list',
          trigger: 'tv-guide-menu-filter-favorites-trigger'
        },
        genres: {
          item: 'tv-guide-menu-filter-genres-item',
          list: 'tv-guide-menu-filter-genres-list',
          root: 'tv-guide-menu-filter-genres-root',
          trigger: 'tv-guide-menu-filter-genres-trigger'
        }
      },
      removeFiltersButton: 'tv-guide-menu-remove-filters-button'
    }
  },
  universe: {
    header: 'universe_header_content'
  },
  universeFilters: {
    genres: {
      item: 'universe-filters_genres-item_content',
      trigger: 'universe-filters-genres-item_button'
    },
    sorting: {
      item: 'universe-filters_sorting-item_content',
      trigger: 'universe-filters_sorting-trigger_button'
    }
  },
  programsheet: {
    content: {
      actors: 'program-sheet-content-actors',
      description: 'program-sheet-content-description',
      directors: 'program-sheet-content-directors',
      progressBar: 'program-sheet-content-progress-bar'
    },
    header: {
      cover: 'program-sheet-header-cover',
      title: 'program-sheet-header-title',
      meta: 'program-sheet-header-meta',
      actions: {
        liveButton: 'program-sheet-header-actions-live',
        startOverButton: 'program-sheet-content-start-over-button'
      }
    },
    info: {
      airtime: 'program-sheet-info-airtime',
      box: 'program-sheet-info-box',
      provider: 'program-sheet-info-provider',
      expiration: {
        root: 'program-sheet-info-expiration-root'
      },
      recordingAction: {
        cancel: 'program-sheet-info-recording-action-cancel',
        start: 'program-sheet-info-recording-action-start'
      }
    }
  },
  liveTv: {
    content: {
      screen: {
        player: {
          cancelRecordingConfirm: {
            cancelText: 'live-tv-content-screen-player-cancel-recording-confirm-cancel-text',
            confirmButton: 'live-tv-content-screen-player-cancel-recording-confirm-confirm-button',
            header: 'live-tv-content-screen-player-cancel-recording-confirm-header',
            rejectButton: 'llive-tv-content-screen-player-cancel-recording-confirm-reject-button',
            root: 'live-tv-content-screen-player-cancel-recording-confirm-root',
            titleText: 'live-tv-content-screen-player-cancel-recording-confirm-title-text'
          }
        }
      }
    },
    contentInfo: {
      current: {
        container: 'live-tv_content-info-current_container'
      },
      next: {
        container: 'live-tv_content-info-next_container',
        cancelRecording: 'live-tv_content-info-next-cancel-recording_button',
        startRecording: 'live-tv_content-info-next-start-recording_button',
        recordingLabel: 'live-tv_content-info-next-recording-label_content'
      },
      headline: 'live-tv_content-info-headline_content',
      title: 'live-tv_content-info-title_content',
      image: 'live-tv_content-info-image_content',
      info: 'live-tv_content-info-info_content',
      airtimes: 'live-tv_content-info-airtimes_content',
      recordingCurrentProgram: 'live-tv_content-info-recording-status_content-current-program',
      recordingNextProgram: 'live-tv_content-info-recording-status_content-next-program'
    },
    sidebar: {
      sort: 'live-tv_sidebar-sort_button',
      list: 'live-tv_sidebar-list_container',
      item: {
        container: 'live-tv_sidebar-item-container_button',
        image: 'live-tv_sidebar-item-image_content',
        title: 'live-tv_sidebar-item-title_content',
        time: 'live-tv_sidebar-item-time_content',
        progressBar: 'live-tv_sidebar-item-progress-bar_content',
        next: {
          time: 'live-tv_sidebar-item-next-time_content',
          title: 'live-tv_sidebar-item-next-title_content'
        }
      }
    }
  },
  player: {
    wrapper: 'player_wrapper_container',
    playerErrorText: 'player_error-text_content',
    playerControls: {
      play: 'player-controls_play_button',
      pause: 'player-controls_pause_button',
      back: 'player-controls_back_button',
      title: 'player-controls_title_content',
      subTitle: 'player-controls_subtitle_content',
      skipBackward: 'player-controls_skip-backward_button',
      skipForward: 'player-controls_skip-forward_button',
      startOver: 'player-controls_start-over_button',
      live: 'player-controls_live_button',
      scrubber: 'player-controls_scrubber_container',
      liveMarker: 'player-controls_live-marker_content',
      mute: 'player-controls_mute_button',
      unmute: 'player-controls_unmute_button',
      volume: 'player-controls_volume_container',
      playtime: 'player-controls_playtime_content',
      settings: 'player-controls_settings_button',
      enterFullscreen: 'player-controls_enter-fullscreen_button',
      exitFullscreen: 'player-controls_exit-fullscreen_button',
      startRecording: 'player-controls_start-recording_button',
      cancelRecording: 'player-controls_cancel-recording_button'
    },
    administerPlayerDevicesDialog: {
      administerPlayerDevicesInfoDialog: 'player_administer-devices-info-dialog',
      administerDevicesButton: 'player_administer-devices-button',
      administerPlayerDevicesMainDialog: 'player_administer-devices-main-dialog',
      administerDevicesRemoveAllButton: 'player_administer-devices-remove-all-button',
      administerDevicesRemoveItemButton: 'player_administer-devices-remove-item-button',
      administerDevicesContinuePlayingButton: 'player_administer-devices-continue-playing-button'
    },
    continueWatchingDialog: {
      continueWatchingInfoDialog: 'player_continue-watching-dialog',
      continueWatchingDialogHeader: 'player_continue-watching-dialog-header',
      continueWatchingButton: 'player_continue-watching-dialog-continue-button',
      startOverButton: 'player_continue-watching-dialog-start-over-button'
    }
  },
  provider: {
    header: {
      logo: 'provider-header-logo'
    },
    navigation: {
      links: {
        root: 'provider-navigation-links',
        item: 'provider-navigation-links-item'
      }
    }
  }
};

export const navigationTestIdMap: { [key: string]: string } = {
  'se livetv': testIds.header.navigation.liveTv,
  'tv guide': testIds.header.navigation.tvGuide,
  lejebutik: testIds.header.navigation.universeRentShop,
  film: testIds.header.navigation.universeMovie,
  serier: testIds.header.navigation.universeSeries,
  børn: testIds.header.navigation.universeKids,
  udsendelser: testIds.header.navigation.universeShows
};

export default testIds;
